export default __webpack_public_path__ + "static/media/hu-logo.3c463b4a.svg";